<div class="subscribe-now-strip" *ngIf="daysLeft !== null">
  <p *ngIf="daysLeft > 0">
    Your free trial will expire in <span>{{ daysLeft }} day{{ daysLeft > 1 ? 's' : '' }}</span>. Upgrade to continue
    accessing all features.
  </p>
  <p *ngIf="daysLeft === 0">
    Your free trial has <span>expired</span>. Upgrade to continue accessing all features.
  </p>
  <!-- <button class="subscribe-btn">Subscribe Now</button> -->
  <button *ngIf="isLoggedIn" class="subscribe-btn" (click)="onUpgrade()">Subscribe Now</button>
  <button *ngIf="!isLoggedIn" class="subscribe-btn" (click)="openModalWithComponent()">Sign Up/Sign</button>
</div>

<div *ngIf="isModalvis">
  <app-signin-with-otp></app-signin-with-otp>
</div>